<template>
  <div>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <h4 class="d-flex align-items-center">
        <font-awesome-icon icon="fas fa-laptop-house" />
        <span class="ml-1">購物禮卷資料</span>
      </h4>
      <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-form class="mt-3" @submit.prevent="handleSubmit(onSubmit)" key="2">
          <div class="mt-2 mt-sm-3 position-relative">
            <b-row>
              <!-- Gift id -->
              <!-- <b-col cols="12" md="6">
                <b-form-group
                  label="購物禮卷編號："
                  label-for="id"
                  label-cols-md="3"
                >
                  <div class="">
                    {{
                      newGiftData.id
                        ? newGiftData.voucher_number
                        : "系統自動生成"
                    }}
                  </div>
                </b-form-group>
              </b-col> -->

              <!-- code -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_code"
                >
                  <b-form-group
                    label="購物禮卷代碼："
                    label-for="code"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="code"
                      v-model="newGiftData.code"
                      placeholder="輸入代碼"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- user_id -->
              <!-- <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="發放人"
                  rules="required"
                >
                  <b-form-group
                    label="發放人："
                    label-for="user_id"
                    label-cols-md="3"
                    class="required"
                  >
                    <v-select
                      id="user_id"
                      v-model="newGiftData.user_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="userOptions"
                      :clearable="false"
                      label="name"
                      :reduce="(option) => option.id"
                      placeholder="選擇發放人"
                      :filter="userSearch"
                    >
                    </v-select>
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col> -->

              <!-- customer_id -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_customer_id"
                >
                  <b-form-group
                    label="客戶："
                    label-for="customer_id"
                    label-cols-md="3"
                    class="required"
                  >
                    <v-select
                      id="customer_id"
                      v-model="newGiftData.customer_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="customerOptions"
                      label="name_cn"
                      :reduce="(option) => option.id"
                      placeholder="選擇客戶"
                      :filter="customerSearch"
                    >
                      <template #option="{ name_cn, user_number }">
                        [{{ user_number }}] {{ name_cn }}
                      </template>
                      <template #selected-option="{ name_cn, user_number }">
                        [{{ user_number }}] {{ name_cn }}
                      </template>
                    </v-select>
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- customer name-->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_name"
                >
                  <b-form-group
                    label="系統帳號名稱："
                    label-for="name"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="name"
                      v-model="newGiftData.name"
                      placeholder="輸入系統帳號名稱"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>
              <!-- theme -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_theme"
                >
                  <b-form-group
                    label="主題："
                    label-for="theme"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="theme"
                      v-model="newGiftData.theme"
                      placeholder="輸入主題"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- amount -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_amount"
                >
                  <b-form-group
                    label="金額："
                    label-for="amount"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="amount"
                      v-model="newGiftData.amount"
                      placeholder="輸入金額"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>
              <!-- message -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_message"
                >
                  <b-form-group
                    label="訊息"
                    label-for="message"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="message"
                      v-model="newGiftData.message"
                      placeholder="輸入訊息"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_status"
                >
                  <b-form-group
                    label="狀態："
                    label-for="status"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-checkbox
                      style="margin-top: 5px"
                      checked="true"
                      value="1"
                      v-model="newGiftData.status"
                      class="custom-control-success"
                      name="check-button"
                      switch
                      inline
                    />

                    <span style="position: relative; top: -5px">{{
                      newGiftData.status ? "啟用 " : "禁用"
                    }}</span>
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>

            <div
              class="d-flex mt-1 flex-wrap flex-lg-nowrap justify-content-end"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-sm-2 phone-w100"
                type="submit"
              >
                <feather-icon size="16" class="mr-1" icon="CheckCircleIcon" />
                提交
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-secondary"
                @click="hide"
                class="mt-1 mt-sm-0 phone-w100"
              >
                取消
              </b-button>
            </div>
          </div>
        </b-form>
      </b-overlay>
    </validation-observer>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BButton,
  BOverlay,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { ref, watch } from "@vue/composition-api";
import vSelect from "vue-select";
import store from "@/store";
import Ripple from "vue-ripple-directive";
import "animate.css";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
localize("zh_cn", zh_CN);
import formValidation from "@core/comp-functions/forms/form-validation";
import { required, email } from "@validations";

export default {
  data() {
    return {
      required,
    };
  },
  directives: {
    Ripple,
  },
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormFile,
    BFormInvalidFeedback,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BRow,
    BCol,
    BButton,
    BOverlay,
    flatPickr,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  methods: {
    hide() {
      this.$router.replace("/coupon/list");
    },
    onSubmit() {
      this.$swal({
        title: "你確定嗎?",
        showCancelButton: true,
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          store
            .dispatch("gift/editGift", this.newGiftData)
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.hide();
              this.$emit("refetech-data");
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    customerSearch(options, search) {
      var returnOptions = options.filter((item) => {
        return (
          item.name.toLowerCase().includes(search.toLowerCase()) ||
          item.customer_number.toLowerCase().includes(search.toLowerCase())
        );
      });
      return returnOptions;
    },
    // userSearch(options, search) {
    //   var returnOptions = options.filter((item) => {
    //     return item.user_number.toLowerCase().includes(search.toLowerCase());
    //   });
    //   return returnOptions;
    // },
    makeToast(variant = null, title = null, content = null) {
      this.$bvToast.toast(content, {
        title: title,
        variant,
        solid: true,
      });
    },
  },
  props: {
    giftData: {
      type: Object,
      required: true,
    },
    // userOptions: {
    //   type: Array,
    //   required: true,
    // },
    customerOptions: {
      type: Array,
      required: true,
    },
  },

  setup(props, { emit }) {
    const newGiftData = ref({ id: 0, status: 1 });

    watch(
      () => props.giftData,
      (newVal) => {
        newGiftData.value = { ...newVal };
      }
    );

    watch(
      () => newGiftData.value.customer_id,
      (newVal, oldVal) => {
        if (props.customerOptions && props.customerOptions.length > 0) {
          const customer = props.customerOptions.filter(
            (ele) => ele.id == newVal
          )[0];

          if (customer) {
            newGiftData.value.name = customer.name;
          }
        }
      }
    );

    const resetGiftsData = () => {
      newGiftData.value = JSON.parse(
        JSON.stringify({
          id: 0,
          status: 1,
        })
      );
    };

    const loading = ref(false);

    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetGiftsData);

    return {
      loading,
      refFormObserver,
      getValidationState,
      resetForm,
      newGiftData,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>

<style lang="scss" scoped>
</style>
